import { render, staticRenderFns } from "./DetalleUtilitario.vue?vue&type=template&id=570ed566&scoped=true&"
import script from "./DetalleUtilitario.vue?vue&type=script&lang=js&"
export * from "./DetalleUtilitario.vue?vue&type=script&lang=js&"
import style0 from "./DetalleUtilitario.vue?vue&type=style&index=0&id=570ed566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570ed566",
  null
  
)

export default component.exports